// extracted by css-extract-rspack-plugin
export default {"Root":"StatusSmall-module__Root___yRCWw","StatusContainer":"StatusSmall-module__StatusContainer___GVdyr","StatusIconContainer":"StatusSmall-module__StatusIconContainer___fNcJ1"};